angular.module( 'acme.view.application.orders.detail.forms.print', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.view.application.orders.detail.forms.print.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersDetailFormsPrint = {
        name: 'application.orders.detail.forms.print',
        url: '/:responseId/print',
        abstract: true,
        views: {
          "main@": {
            controller: 'OrdersDetailFormsPrintController',
            templateUrl: 'layouts/print.tpl.html'
          }
        },
        resolve: {
          ResponseData: [ 'ApiService', '$stateParams',  function(ApiService, $stateParams) {
            return ApiService.orders.forms.response({
              orderId: $stateParams.orderId,
              responseId: $stateParams.responseId
            });
          }]
        }
      },
      ordersDetailFormsPrintDefault = {
        name: 'application.orders.detail.forms.print.default',
        url: '',
        views: {
          "subview-main": {
            templateUrl: 'views/application/views/orders/detail/forms/print/print.tpl.html'
          }
        },
        data: {
          pageTitle: 'Print Response'
        },
        resolve: {
          JQueryPrint: ['$q', function($q) {

            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/jquery-print.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;
          }]
        }
      };

    $stateProvider
      .state(ordersDetailFormsPrint)
      .state(ordersDetailFormsPrintDefault);
});
